import { useGetAllPastBookings } from "@/queries/past-bookings/get-all";

import { Card } from "./card";

type Props = {
  supplierName: string;
  supplierId: string;
  supplierNo: string;
};

export const SameSupplierBookings = ({
  supplierName,
  supplierNo,
  supplierId,
}: Props) => {
  const { data: invoices, loading } = useGetAllPastBookings({
    supplierId,
  });

  return (
    <Card
      loading={loading}
      invoices={invoices}
      title={`${supplierName} (${supplierNo})`}
      columnVisibility={{ supplierName: false }}
    />
  );
};
